/**
 * NF-e cUF (SEFAZ UF code) constants.
 * @see http://www.nfe.fazenda.gov.br/portal/listaConteudo.aspx?tipoConteudo=Il8k4BIjb48=
 */

export const NFE_CUF_MANUAL_UF_URL =
  'http://www.nfe.fazenda.gov.br/portal/listaConteudo.aspx?tipoConteudo=Il8k4BIjb48=';

export const NFE_PORTAL_URL = 'http://www.nfe.fazenda.gov.br/portal/principal.aspx';

export const IBGE_UF_CODES_URL = 'https://www.ibge.gov.br/explica/codigos-dos-municipios.php';

export const NFE_CUF_COUNT = 27;

export const NFE_CUF_GOLDEN_SP = '35';
